import React from "react";
import { useParams } from "react-router-dom";

const Childupload = ({ ClassDetails, setModalbox }) => {
  const { school_id, class_id } = useParams();
  const AddChild = () => {
    setModalbox((prev) => ({ ...prev, addchild: true }));
  };
  const Uploadmodal = () => {
    setModalbox((prev) => ({ ...prev, uploadchild: true }));
  };
  return (
    <div className="flex items-center justify-between py-2 px-2 max-[700px]:flex-col max-[700px]:items-start">
      <p className="text-lg font-semibold">
        List of student in{" "}
        {atob(class_id) != "other" ? ClassDetails?.standard : "Others"}
      </p>

      <div className="max-[700px]:my-2 flex justify-center max-[700px]:w-full">
        <button
          className="text-sm bg-[white] text-[#f79221] font-semibold mx-3 border-2 border-[#ffcd94] px-2 py-1 rounded"
          onClick={AddChild}
        >
          <i className="fa-solid fa-plus"></i> Add child
        </button>
        <button
          className="text-sm bg-[white] text-[#f79221] font-semibold mx-3 border-2 border-[#ffcd94] px-2 py-1 rounded"
          onClick={Uploadmodal}
        >
          <i className="fa-solid fa-upload"></i> Upload list
        </button>
      </div>
    </div>
  );
};

export default Childupload;
